import Hashes from 'jshashes'

export function md5(str) {
  return new Hashes.MD5().hex(str)
}
